// **** External Utilities ****
import axios from 'axios';

import { URL_CONSTANTS } from '../../../../../constants/urlConstants';
import { Notifications } from '../../../../../constants/notification.constant';
import { updateNotificationViewed } from '../../../../shared/Topbar/Notification/Notification.service';
import { REACT_APP_ENABLE_PUSH_NOTIFICATION } from '../../../../../constants/envConstants';

//Mark Message as read
export const markMessageAsRead = async (sms_log_id, clearAll) => {
  try {
    let query = `clearAll=${clearAll}`;

    if (sms_log_id) {
      query += `&id=${sms_log_id}`;
    }

    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/customers/message/updateStatus?${query}`
    );
    if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
      await updateNotificationViewed(
        sms_log_id,
        Notifications.SMS,
        localStorage.getItem('user_id'),
        true,
        false
      );
    }
  } catch (error) {
    console.log(error);
  }
};

export const markMessageAsReviewed = async sms_log_id => {
  try {
    let query = `id=${sms_log_id}`;
    await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/customers/message/reviewed?${query}`
    );
    if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
      await updateNotificationViewed(
        sms_log_id,
        Notifications.SMS,
        localStorage.getItem('user_id'),
        false,
        true
      );
    }
  } catch (error) {
    console.log(error);
  }
};
